module.exports = require("events");


/*****************
 ** WEBPACK FOOTER
 ** external "events"
 ** module id = 233
 ** module chunks = 0
 **/